module.exports = __webpack_public_path__ + "static/img/35.06316c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/35.png
// module id = ebsy
// module chunks = 0